import React, { Component } from "react";
import DocumentsForm from "../DocumentsForm/DocumentsForm";
import "filepond/dist/filepond.min.css";
import {Button} from "rsuite";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";

class StakeholderDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadType: "stakeholder_video",
            currentDocument: null
        };
    }

  componentDidMount() {
    this.props.fetch(this.props.currentProjectID);
  }

  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
          <SmallModal>
            <DocumentsForm
                type={this.state.uploadType}
                add={this.props.add}
                update={this.props.documents.update}
                projectID={this.props.currentProjectID}
                toggleSmallModalHandler={this.props.toggleSmallModalHandler}
                currentDocument={this.state.currentDocument}
            />
          </SmallModal>
      );
    }

    let stakeholder_docs = this.props.documents.filter(document =>
        document.file_type === "stakeholder_picture" || document.file_type === "stakeholder_video");

    return (
      <div className="container-fluid">
          {this.props.disabled ? null : (
              <div
                  style={{textAlign: "right"}}
              >
                  <Button
                      className="my-2 col-2"
                      color="blue"
                      disabled={stakeholder_docs.length > 0}
                      onClick={() => {
                          this.setState({uploadType: "stakeholder_picture", currentDocument: null});
                          this.props.toggleSmallModalHandler();
                      }}
                  >
                      Upload Picture
                  </Button>
                  {' '}
                  <Button
                      className="my-2 col-2 dblock"
                      color="blue"
                      disabled={stakeholder_docs.length > 0}
                      onClick={() => {
                          this.setState({uploadType: "stakeholder_video", currentDocument: null});
                          this.props.toggleSmallModalHandler();
                      }}
                  >
                      Upload Video
                  </Button>
              </div>
          )}
        {smallModal}

        <h1>Stakeholder Document </h1>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Source</th>
              <th>Security Level</th>
              <th>Link</th>
              <th>Time Stamp</th>
              {this.props.disabled ? null : (<th>Delete</th>)}
            </tr>
          </thead>
          <tbody>
            {stakeholder_docs
              .map(document => (
                  <tr key={document.upload_tstamp}
                      onClick={e => {
                          if (e.target.type !== "button" && e.target.tagName.toLowerCase() !== 'a') {
                              this.setState({
                                  currentDocument: document
                              });
                              this.props.toggleSmallModalHandler();
                          }
                      }}
                  >
                  <td>{document.file_name}</td>
                  <td>{document.file_source}</td>
                  <td>{document.security_level}</td>
                  <td>
                    <a href={document.file_url} target={"_blank"}>Click to view</a>
                  </td>
                  <td><span className={"text-nowrap"}>{document.upload_tstamp.slice(0, 10)}&nbsp;{document.upload_tstamp.slice(11, 16)}</span></td>
                    {this.props.disabled ? null : (
                      <td>
                          <Button
                              type="button"
                              color="red"
                              onClick={() => {
                                this.props.delete(document.project_file_id);
                              }}
                          >
                              Delete
                          </Button>
                      </td>
                    )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default StakeholderDocuments;
